import { Button, Card, Grid, Modal, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { useState } from 'react';
import { useEditFormContext } from 'pages/formsCreate/context';
import React from 'react';

export const DiscartChangesButton = () => {
  const styles = useStyles();
  const { handleCancelEdition } = useEditFormContext();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleConfirm = () => {
    handleCancelEdition();
    handleModalOpen();
  };

  return (
    <>
      <Modal open={isModalOpen} onClose={handleModalOpen} className={styles.modal}>
        <Grid
          item
          xs={10}
          sm={8}
          md={6}
          style={{ padding: '16px' }}
          container
          direction="column"
          spacing={1}
          component={Card}
        >
          <Typography align="center" variant="h6">
            Deseja descartar as alterações?
          </Typography>
          <Grid item container className={styles.buttonContainer}>
            <Button className={styles.button} onClick={handleConfirm} variant="contained">
              Confirmar
            </Button>
            <Button className={styles.buttonApply} onClick={handleModalOpen} variant="text">
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <Button className={styles.buttonDiscart} onClick={handleModalOpen}>
        Descartar alterações
      </Button>
    </>
  );
};
